import React, { Suspense, useContext, useEffect } from 'react'
import ObservationsMap from './components/Map/ObservationsMap';
import SidePanel from '../../components/SidePanel/SidePanel';
import ObservationsSidePanel from './components/ObservationsSidePanel/ObservationsSidePanel';
import { useLocation } from 'react-router-dom';
import { MapContext } from '../../App/MapContextContainer';
import Point from '@arcgis/core/geometry/Point';
import MapAndSidePanelContainer from '../../components/SidePanel/MapAndSidePanelContainer';
import ObservationsContextContainer from './ObservationsContextContainer';
import PageContextContainer, { PageContext } from '../../App/PageContextContainer';
import errors from '../../App/errors';

export default function ObservationsPage() {
    const mapContext = useContext(MapContext);
    const loc = useLocation();
    const pageContext = useContext(PageContext);

    useEffect(() => {
        const searchString = loc.search;

        if (mapContext.mapAndViewReady && searchString && searchString.startsWith("?havaintoUri")) {
            const observationUnitId = searchString.split("=")[1];

            if (observationUnitId && observationUnitId.startsWith("http://")) {
                const asyncCall = async () => {
                    let url = new URL("https://api.laji.fi/v0/warehouse/query/unit/list?");
                    const params = new URLSearchParams({
                        "access_token": `${process.env.REACT_APP_LAJIFI_TOKEN}`,
                        "featureType": "CENTER_POINT",
                        "cache": "true",
                        "selected": "unit.unitId",
                        "format": "geojson",
                        "pageSize": "1",
                        "unitId": observationUnitId + loc.hash
                    });

                    // NOTE: Sometimes the Laji.fi unitids have a hash as well so that shows up in the url as a url hash and is
                    // therefore found in loc.hash. If it does not exist it is empty string so no problems.

                    url.search = params.toString();

                    const response = await fetch(url.toString());

                    if (response.status === 200) {
                        const json = await response.json();

                        if (json.features.length > 0) {
                            const firstFeature = json.features[0];

                            const pointToNavigateTo = new Point({
                                longitude: firstFeature.geometry.coordinates[0],
                                latitude: firstFeature.geometry.coordinates[1]
                            });

                            mapContext.navigateToPoint(pointToNavigateTo);
                        }
                    }
                    else {
                        console.log("Failed to get observation");

                        pageContext.setMapError(errors.failedToNavigateToObservationClash);
                    }
                }

                asyncCall();
            }
        }
    }, [mapContext.mapAndViewReady, loc.search]);

    return (
        <PageContextContainer>
            <ObservationsContextContainer>
                <MapAndSidePanelContainer>
                    <ObservationsMap />
                    <Suspense fallback={<></>}>
                        <SidePanel>
                            <></>
                            <ObservationsSidePanel></ObservationsSidePanel>
                        </SidePanel>
                    </Suspense>
                </MapAndSidePanelContainer>
            </ObservationsContextContainer>
        </PageContextContainer>
    )
}